var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.switchMode
      ? _c("h2", [_vm._v(_vm._s(_vm.$t("wp.purchaseHeader")))])
      : _vm._e(),
    _vm._v(" "),
    !_vm.switchMode
      ? _c("span", [
          _vm._v(" " + _vm._s(_vm.$t("wp.purchasePaymentDescription"))),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.switchMode
      ? _c("h2", [_vm._v(_vm._s(_vm.$t("wp.whatsappPlans")))])
      : _vm._e(),
    _vm._v(" "),
    _vm.switchMode
      ? _c("span", [_vm._v(_vm._s(_vm.$t("wp.selectBestPlan")))])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "plans mt-5" },
      [
        _c("WhatsappBasicPlanCard", {
          attrs: {
            selected: _vm.whatsappBasicEnabled,
            "on-selected": function () {
              return _vm.onPlanSelected("whatsapp")
            },
          },
        }),
        _vm._v(" "),
        _c("WhatsappPlusPlanCard", {
          attrs: {
            selected: _vm.whatsappPlusEnabled,
            "on-selected": function () {
              return _vm.onPlanSelected("whatsapp-plus")
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }